









import Vue from 'vue';
import { Component } from 'vue-property-decorator';
interface ImageObject {
  url: string;
  width: number;
  height: number;
}
@Component({
  components: {},
})
export default class DevLayoutIcons extends Vue {
  private images = require.context('../assets/', true, /\.jpg|.svg|.png$/);

  private imageList: string[] = this.images.keys().map((image: string) => this.images(image));

  public parsedImg: ImageObject[] = [];

  private mounted(): void {
    this.imageList.forEach((image: string) => {
      const img = new Image();
      img.onload = () => {
        this.parsedImg.push({
          url: image,
          width: img.width,
          height: img.height,
        });
      };
      img.src = image;
    });
  }
}
